import { Box } from '@mui/material';

import { loomEmbedUrl } from '../../lib/knowledgeBase';

type LoomEmbedProps = {
  loomId: string;
  title: string;
};

export function LoomEmbed({ loomId, title }: LoomEmbedProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        pb: '56.25%',
        height: 0,
        overflow: 'hidden',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.default',
      }}
    >
      <Box
        component="iframe"
        title={title}
        src={loomEmbedUrl(loomId)}
        allowFullScreen
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          border: 0,
        }}
      />
    </Box>
  );
}
